// Import the stylesheet for webpack
import '@/styles/app.scss'

import { polyfillCountryFlagEmojis } from '@/scripts/plugins/country-flag-emoji-polyfill'
polyfillCountryFlagEmojis();

import '@/scripts/plugins/editorjs/editorjs.init'

import '@/scripts/plugins/fslightbox/fslightbox.js'
if (typeof fsLightbox !== 'undefined' && fsLightbox.props) {
   fsLightbox.props.showThumbsOnMount = true;
   fsLightbox.props.slideshowTime = 3000;
}

import '@/scripts/components/common/ui'